/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TableRowRemoveCenterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Table Row Remove Center',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.9 19a8.9 8.9 0 1 0-8.9 8.9 8.9 8.9 0 0 0 8.9-8.9Zm-3.9.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Z"
    />
    <path
      d="M2 3v32a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.893a12.139 12.139 0 0 1-2 1.123V34h-8v-3.084a12.139 12.139 0 0 1-2-.684V34h-8v-8h3.308a12.229 12.229 0 0 1-1.808-4H6v-6h9.5a12.229 12.229 0 0 1 1.809-4H14V4h8v3.769a12.154 12.154 0 0 1 2-.685V4h8v3.769a12.108 12.108 0 0 1 2 1.123V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Zm10 23v8H4v-8Zm0-22v8H4V4Z"
    />
  </svg>`;
};
